import "./Search.scss";
const Search = () => {
    return <div>Search</div>;
};

export default Search;
